module.exports = __webpack_public_path__ + "static/assets/5ee196e64ae6fbe6827622eff5001ad4.svg";